export const CLI_KIT_VERSION = '3.48.3'
